module.exports = __webpack_public_path__ + "img/kr.bb966161.svg";